export default {
    ListaDePresenca: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "lista-de-presenca"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/ListaDePresenca.js
// module id = MZJZ
// module chunks = 32